<div style="background-image: linear-gradient(to right, #3791e5 0%, #45cdd8 100%);">
    <div class="container pt-4 pb-4 mb-4">
        <a href="#"><img src="assets/img/svg/logo_white.svg" /></a>
    </div>
</div>
<div class="container">
    <div class="content-wrapper">

        <div class="row">
            <div class="container p-30 text-center">
                <h3 class="h1">Email Verification</h3>
                <h4 *ngIf="success">Congratulations! Your email has been verified.</h4>
                <h4 *ngIf="errorMessage">{{errorMessage}}</h4>

            </div>
        </div>
    </div>
</div>